import React from 'react';
import { Box, Container, Typography, Grid, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[900],
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        {/* <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              About Us
            </Typography>
            <Typography variant="body2" color="grey.400">
              Lakshya Institute is a premier educational institution providing quality education
              and scholarship opportunities to students across India.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Quick Links
            </Typography>
            <Link href="/" color="inherit" display="block" sx={{ mb: 1 }}>
              Home
            </Link>
            <Link href="/page2" color="inherit" display="block" sx={{ mb: 1 }}>
              Register
            </Link>
            // <Link href="/login" color="inherit" display="block" sx={{ mb: 1 }}>
            //   Login
            // </Link>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="white" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" color="grey.400">
              Email: support@Lakshya.ac.in
              <br />
              Phone: 1800-102-2727
              <br />
              Address: Lakshya Tower, Plot No. 4, Sector 11, Dwarka, New Delhi - 110075
            </Typography>
          </Grid>
        </Grid> */}
        <Box mt={0}>
          <Typography variant="body2" color="grey.400" align="center">
            {'© '}
            {new Date().getFullYear()}
            {' Lakshya Institute. All rights reserved.'}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 